import { createReducer, on } from '@ngrx/store';
import { BankRecord, DebitOrder, IBankDetails } from '../../models/finance';
import { AccountLinks, IAccountHolder } from '../../models/user';
import { resetAppState } from '../global/global.actions';
import { FinanceActions } from './finance.actions';
import { IBursar } from '../../graphql/models/gqlModels';

export const itemsFeatureKey = 'finance';

export interface FinanceState {
    debitOrders: DebitOrder[];
    bankDetails: IBankDetails[];
    bankRecords: BankRecord[];
    accountHolder: IAccountHolder | null;
    selectedAccountLinks?: AccountLinks;
    accountBursar?: IBursar | null;
    loading: boolean;
    error: unknown | null;
    fromDate?: Date;
    toDate?: Date;
}

export const initialState: FinanceState = {
    debitOrders: [],
    bankRecords: [],
    bankDetails: [],
    accountHolder: null,
    loading: false,
    error: null,
    fromDate: new Date(new Date().setFullYear(new Date().getFullYear() - 1)), // Default to one year ago
    toDate: new Date() // Default to today
};

export const financeReducer = createReducer(
    initialState,
    on(FinanceActions.loadDebitOrders, state => ({
        ...state,
        loading: true,
        error: null
    })),
    on(FinanceActions.loadDebitOrdersSuccess, (state, { debitOrders }) => ({
        ...state,
        debitOrders,
        loading: false,
        error: null
    })),
    on(FinanceActions.loadDebitOrdersFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error
    })),
    on(FinanceActions.loadBankingDetails, state => ({
        ...state,
        loading: true,
        error: null
    })),
    on(FinanceActions.loadBankingDetailsSuccess, (state, { bankDetails }) => ({
        ...state,
        bankDetails,
        loading: false,
        error: null
    })),
    on(FinanceActions.loadBankingDetailsFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error
    })),
    on(FinanceActions.loadBankRecords, state => ({
        ...state,
        loading: true,
        error: null
    })),
    on(FinanceActions.loadBankRecordsSuccess, (state, { statements }) => ({
        ...state,
        bankRecords: statements,
        loading: false,
        error: null
    })),
    on(FinanceActions.loadBankRecordsFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error
    })),
    on(FinanceActions.setDateRange, (state, { fromDate, toDate }) => ({
        ...state,
        fromDate,
        toDate
    })),
    on(FinanceActions.setSelectedAccountLinks, (state, { accountLinks }) => ({
        ...state,
        selectedAccountLinks: accountLinks
    })),
    on(FinanceActions.loadAccountHolderDetails, state => ({
        ...state,
        loading: true,
        error: null
    })),
    on(FinanceActions.loadAccountHolderDetailsSuccess, (state, { accountHolder }) => ({
        ...state,
        accountHolder,
        loading: false,
        error: null
    })),
    on(FinanceActions.loadAccountHolderDetailsFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error
    })),
    on(FinanceActions.setAccountBursar, (state, { accountBursar }) => ({
        ...state,
        accountBursar: accountBursar
    })),
    on(resetAppState, () => initialState)
);